export const loadSkill = async (skill) =>
{
    const filePath = `./${skill}.json`;
    const file = await require(`${filePath}`);
    return file;
};